import { createBrowserRouter } from 'react-router'
import { AppShell } from '@/components/layout/app-shell'
import { RequireAccess } from '@/providers/access'
import LoginPage from '@/pages/login'
import OverviewPage from '@/pages/overview'
import TeamsPage from '@/pages/teams'
import TeamDetailPage from '@/pages/team-detail'
import UsersPage from '@/pages/users'
import SubscriptionsPage from '@/pages/subscriptions'
import InvoicesPage from '@/pages/invoices'
import PlansPage from '@/pages/plans'
import NotFoundPage from '@/pages/not-found'

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <RequireAccess />,
    children: [
      {
        element: <AppShell />,
        children: [
          { index: true, element: <OverviewPage /> },
          { path: 'teams', element: <TeamsPage /> },
          { path: 'teams/:id', element: <TeamDetailPage /> },
          { path: 'users', element: <UsersPage /> },
          { path: 'subscriptions', element: <SubscriptionsPage /> },
          { path: 'invoices', element: <InvoicesPage /> },
          { path: 'plans', element: <PlansPage /> },
          { path: '*', element: <NotFoundPage /> },
        ],
      },
    ],
  },
])
